module.exports = __webpack_public_path__ + "img/upper_pocket_entry_length.ca53fb9b.png";